import { CasesAdmin, SlideAdmin } from "pwapi";

import { CaseAdminDetail } from "./adminCaseReducer";
import {
  ADMIN_SLIDE_SET,
  ADMIN_UPDATE_SLIDE_SUCCESS,
  ADMIN_SLIDE_SUCCESS,
  ADMIN_UPDATE_SLIDE_FAILURE,
  ADMIN_UPDATE_SLIDE_REQUEST,
  ADMIN_UPDATE_SPECIMEN_SUCCESS,
  ADMIN_DELETE_SLIDE_SUCCESS,
  ADMIN_SLIDES_RUN_ACTION_SUCCESS,
  ADMIN_SLIDES_RUN_ACTION_FAILURE,
  ADMIN_SLIDES_RUN_ACTION_REQUEST,
  ADMIN_SLIDES_ACTION_RESET,
  ADMIN_SLIDE_REQUEST,
  ADMIN_SLIDE_FAILURE,
  ADMIN_SLIDE_MACRO_SET,
  ADMIN_SLIDE_BARCODE_SET,
} from "../../actions/adminConstants";

type ModifiedSlideAdmin = Omit<SlideAdmin, "case"> & {
  case?: CaseAdminDetail | CasesAdmin;
};

export type SlideUrls = {
  barcode_url?: {
    url?: string;
    error?: boolean;
  };
  macro_url?: {
    url: string;
    error: boolean;
  };
  isLoading?: boolean;
  actionRequestState?: "loading" | "success" | "error";
  metadata: {
    /**
     * Set to true if a user decides to mark the slide as unfit for AI training
     */
    ignore_in_ai?: boolean;
    readonly last_author?: string;
  };
};

export type SlideAdminWithUrls = ModifiedSlideAdmin & SlideUrls;

const reducer = (
  state: SlideAdminWithUrls | null = null,
  action: any
): SlideAdminWithUrls | null => {
  switch (action.type) {
    case ADMIN_UPDATE_SLIDE_REQUEST:
      return state
        ? {
            ...state,
            isLoading: true,
          }
        : state;
    case ADMIN_UPDATE_SLIDE_FAILURE:
      return state
        ? {
            ...state,
            isLoading: false,
          }
        : state;
    case ADMIN_UPDATE_SPECIMEN_SUCCESS:
      return state && state.specimen?.id === action.payload.specimen.id
        ? {
            ...state,
            specimen: {
              ...state.specimen,
              ...action.payload.specimen,
            },
          }
        : state;
    case ADMIN_SLIDE_REQUEST:
      return state
        ? {
            ...state,
            isLoading: true,
          }
        : {
            flags: [],
            isLoading: true,
            metadata: {},
          };
    case ADMIN_SLIDE_FAILURE:
      return state
        ? {
            ...state,
            isLoading: false,
          }
        : {
            flags: [],
            isLoading: false,
            metadata: {},
          };
    case ADMIN_SLIDE_SUCCESS:
      return {
        ...action.payload.response,
        isLoading: false,
      };
    case ADMIN_SLIDE_SET:
      return {
        ...action.payload,
        isLoading: false,
      };
    case ADMIN_UPDATE_SLIDE_SUCCESS:
    case ADMIN_DELETE_SLIDE_SUCCESS:
      return null;
    case ADMIN_SLIDES_ACTION_RESET:
      return state
        ? {
            ...state,
            actionRequestState: undefined,
          }
        : null;
    case ADMIN_SLIDES_RUN_ACTION_REQUEST:
      return state
        ? {
            ...state,
            actionRequestState: "loading",
          }
        : null;
    case ADMIN_SLIDES_RUN_ACTION_FAILURE:
      return state
        ? {
            ...state,
            actionRequestState: "error",
          }
        : null;
    case ADMIN_SLIDES_RUN_ACTION_SUCCESS:
      return state
        ? {
            ...state,
            actionRequestState: "success",
          }
        : null;
    case ADMIN_SLIDE_BARCODE_SET:
      return state
        ? {
            ...state,
            barcode_url: action.payload.url,
          }
        : null;
    case ADMIN_SLIDE_MACRO_SET:
      return state
        ? {
            ...state,
            macro_url: action.payload.url,
          }
        : null;
    default:
      return state;
  }
};

export default reducer;
